import { render, staticRenderFns } from "./PatientPhoto.vue?vue&type=template&id=182d5686"
import script from "./PatientPhoto.vue?vue&type=script&lang=js"
export * from "./PatientPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports